module.exports = __webpack_public_path__ + "images/collections/collections-black.9dc0b9b8f7804172b734.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/collections/collections-black.svg
// module id = yuVW
// module chunks = 1